class ProductFormOld extends Cart {
  constructor(subscriptionOptions) {
    super(product)
    this.product = product
    this.subscriptionOptions = subscriptionOptions
    // this.initializeForm(product)
    console.log(product)
    console.log(subscriptionOptions)

    this.checkbox = document.querySelector("#newprice")
    this.checkbox2 = document.querySelector("#newprice2")

    if (this.checkbox) {
      this.checkbox.addEventListener("change", (event) => {
        const isChecked = event.target.checked
        if (event.target.checked) {
          // document.querySelectorAll('.pdp-weight-text').forEach(e => {
          //   e.style.display = 'none'
          // })
          this.checkbox2.checked = isChecked
          this.loadNewProduct()
        } else {
          // document.querySelectorAll('.pdp-weight-text').forEach(e => {
          //   e.style.display = 'block'
          // })
          this.checkbox2.checked = isChecked
          this.initializeFormReInit(this.product)
        }
      })
    }
    if (this.checkbox2) {
      this.checkbox2.addEventListener("change", (event) => {
        const isChecked = event.target.checked
        if (event.target.checked) {
          // document.querySelectorAll('.pdp-weight-text').forEach(e => {
          //   e.style.display = 'none'
          // })
          this.checkbox.checked = isChecked
          this.loadNewProduct2()
        } else {
          // document.querySelectorAll('.pdp-weight-text').forEach(e => {
          //   e.style.display = 'block'
          // })
          this.checkbox.checked = isChecked
          this.initializeFormReInit2(this.product)
        }
      })
    }
  }

  
  isVariantAvailable(weight) {
    const variant = window.globalState.allVariants.find(v => v.title == `${weight}lbs`);
    return variant && variant.available;
  }
  
  updateAddToCartButton() {
    const oneTimeBtn = document.querySelector(".template-old #one-time-purchase-add-to-cart"),
        subBtn = document.querySelector(".template-old #subscribe-and-save-add-to-cart"),
        variant = window.globalState.allVariants.find(v => v.id == window.globalState.selectedVariantId),
        tenLbVariant = window.globalState.allVariants.find(v => v.title == "10lbs"),
        tenLbCheckbox = document.querySelector("#newprice"),
        tenLbCheckbox2 = document.querySelector("#newprice2");

        // --- NEW DYNAMIC PRICE UPDATE LOGIC ---
        if (variant) {
          const discountLoad = document.querySelector('.discount-price-load');
          const simpleLoad = document.querySelector('.simple-price-load');
          
          if (discountLoad && simpleLoad) {
            // Calculate the base price, the 18% off sub price, and the 30% off promo price
            const basePrice = variant.price / 100;
            const subPrice = basePrice * 0.82; // Applies the 18% subscription discount
            
            // Cross out the subscription price and show the extra 30% off
            simpleLoad.textContent = this.formatter.format(subPrice);
            discountLoad.textContent = this.formatter.format(subPrice * 0.70);
          }
        }
    // ---------------------------------------

    tenLbVariant && !tenLbVariant.available ? (tenLbCheckbox && (tenLbCheckbox.disabled = !0, tenLbCheckbox.checked = !1, tenLbCheckbox.closest("label")?.classList.add("disabled-checkbox")), tenLbCheckbox2 && (tenLbCheckbox2.disabled = !0, tenLbCheckbox2.checked = !1, tenLbCheckbox2.closest("label")?.classList.add("disabled-checkbox"))) : (tenLbCheckbox && (tenLbCheckbox.disabled = !1, tenLbCheckbox.closest("label")?.classList.remove("disabled-checkbox")), tenLbCheckbox2 && (tenLbCheckbox2.disabled = !1, tenLbCheckbox2.closest("label")?.classList.remove("disabled-checkbox")));

    variant && !variant.available ? (oneTimeBtn && (oneTimeBtn.disabled = !0, oneTimeBtn.textContent = "Sold Out", oneTimeBtn.classList.add("sold-out")), subBtn && (subBtn.disabled = !0, subBtn.textContent = "Sold Out", subBtn.classList.add("sold-out"))) : (oneTimeBtn && (
        oneTimeBtn.disabled = !1,
        
        oneTimeBtn.textContent = "Add To Cart ", 
        this.oneTimePurchaseProductPrice && oneTimeBtn.appendChild(this.oneTimePurchaseProductPrice),
        
        oneTimeBtn.classList.remove("sold-out")
    ), subBtn && (subBtn.disabled = !1, subBtn.textContent = "Add To Cart", subBtn.classList.remove("sold-out")))
}

  initializeForm(product = this.product) {
    if (typeof product.selling_plan_groups[0] !== "undefined") {
      var selling_plans = product.selling_plan_groups[0].selling_plans
      var selling_plans2 = product.selling_plan_groups
    } else {
      jQuery.getJSON(window.Shopify.routes.root + "products/" + product.handle + ".js", function (new_product) {
        var selling_plans = new_product.selling_plan_groups[0].selling_plans
        var selling_plans2 = new_product.selling_plan_groups[0]
      })
    }

    window.globalState = {
      numberOfCatsSelected: 1,
      productWeight: 10,
      remainder: 10,
      rechargeInterval: 0,
      purchaseType: "one-time-purchase",
      selectedVariantId: selected_variant.id,
      allVariants: product.variants,
      selectedBeingEditingVariantLine: null,
      sellingPlans: selling_plans,
      sellingPlans2: selling_plans2,
      count: 1,
    }

    this.oneTimePurchaseFormBlock = document.querySelector(".template-old #one-time-purchase-form-block")
    this.subscribeAndSaveFormBlock = document.querySelector(".template-old #subscribe-and-save-form-block")

    this.numberOfCatsCheckboxes = document.querySelectorAll(".template-old input[name='number-of-cats']")
    this.numberOfCatsManualCounters = document.querySelectorAll(".template-old button[name='number-of-cats-manual-counter']")
    this.numberOfCatsManualCounterValue = document.querySelector(".template-old #number-of-cats-manual-value")
    this.numberOfCatsManualCounterWrapper = document.querySelector(".template-old #number-of-cats-manual-counter-wrapper")

    this.oneTimePurchaseProductPrice = document.querySelector(".template-old #one-time-purchase-product-price")
    this.oneTimePurchaseProductWeightValue = document.querySelector(".template-old #one-time-purchase-product-weight-value")
    this.oneTimePurchaseProductWeightCounters = document.querySelectorAll(".template-old button[name='product-weight-counter']")
    this.freeSheepingBlock = document.querySelector(".template-old #free-sheeping-block")
    this.subscriptionOptions = subscriptionOptions

    this.overlay = document.getElementById("overlay")
    this.closeButton = document.querySelector(".pdp-modal__close")
    this.modal = document.querySelector(".pdp-modal")

    this.sub4Element = document.querySelector("#bag-add-to-cart-sub4")
    this.subElement = document.querySelector("#bag-add-to-cart-sub")

    this.init()
  }
  initializeFormReInit(product) {
    if (typeof product.selling_plan_groups[0] !== "undefined") {
      var selling_plans = product.selling_plan_groups[0].selling_plans
      var selling_plans2 = product.selling_plan_groups
    } else {
      jQuery.getJSON(window.Shopify.routes.root + "products/" + product.handle + ".js", function (new_product) {
        var selling_plans = new_product.selling_plan_groups[0].selling_plans
        var selling_plans2 = new_product.selling_plan_groups[0]
      })
    }

    this.subscriptionOptions = subscriptionOptions
    window.globalState.sellingPlans = selling_plans
    window.globalState.sellingPlans2 = selling_plans2
    window.globalState.allVariants = product.variants
    window.globalState.selectedVariantId = selected_variant.id
    this.renderSubAndSaveOptions()
    let cat = window.globalState.productWeight / 10
    this.showSavingsValueInfoOne(`cat_${cat}`, window.globalState.productWeight)
    this.showSavingsValue2(`cat_${cat}`, window.globalState.productWeight)
    

  }
  initializeFormReInit2(product) {
    console.log(product.title + "===" + window.globalState.selectedVariantId)

    if (typeof product.selling_plan_groups[0] !== "undefined") {
      var selling_plans = product.selling_plan_groups[0].selling_plans
      var selling_plans2 = product.selling_plan_groups
    } else {
      jQuery.getJSON(window.Shopify.routes.root + "products/" + product.handle + ".js", function (new_product) {
        var selling_plans = new_product.selling_plan_groups[0].selling_plans
        var selling_plans2 = new_product.selling_plan_groups[0]
      })
    }

    this.subscriptionOptions = subscriptionOptions
    window.globalState.sellingPlans = selling_plans
    window.globalState.sellingPlans2 = selling_plans2
    window.globalState.allVariants = product.variants

    let selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == `${window.globalState.productWeight}lbs`)
    window.globalState.selectedVariantId = window.globalState.allVariants[selectedVariantIndex].id
    this.oneTimePurchaseProductPrice.innerHTML = `${this.formatter.format(window.globalState.allVariants[selectedVariantIndex].price / 100)}`
    let cat = window.globalState.productWeight / 10
    this.showSavingsValueInfoOne(`cat_${cat}`, window.globalState.productWeight)
  }
  loadNewProduct() {
    let newProductHandle = "cat-litter-healthy-cat-copy" // handle new product
    if (product.title == "Cat Litter Healthy Cat") {
      newProductHandle = "cat-litter-healthy-cat-copy" // handle new product
    } else if (product.title == "Cat Litter Multi-Cat") {
      newProductHandle = "cat-litter-multi-cat-copy"
    } else {
      newProductHandle = "cat-litter-unscented-copy"
    }
    jQuery.getJSON(window.Shopify.routes.root + "products/" + newProductHandle + ".js", (new_product) => {
      this.initializeFormReInit(new_product)
    })
  }
  loadNewProduct2() {
    let newProductHandle = "cat-litter-healthy-cat-copy" // handle new product
    if (product.title == "Cat Litter Healthy Cat") {
      newProductHandle = "cat-litter-healthy-cat-copy" // handle new product
    } else if (product.title == "Cat Litter Multi-Cat") {
      newProductHandle = "cat-litter-multi-cat-copy"
    } else {
      newProductHandle = "cat-litter-unscented-copy"
    }

    jQuery.getJSON(window.Shopify.routes.root + "products/" + newProductHandle + ".js", (new_product) => {
      this.initializeFormReInit2(new_product)
    })
  }
  async fetchCart() {
    const response = await fetch("/cart.js")
    if (!response.ok) {
      throw new Error("Error fetching cart")
    }
    const cart = await response.json()
    return cart
  }
  checkOnlyFourMonthSubscription(cart) {
    if (cart.items.length > 0) {
      return cart.items.every((item) => item.product_type === "Cat Litter" && item.properties && item.properties._interval === 4)
    } else {
      return false
    }
  }
  updateDisplay(onlyFourMonthSubscription) {
    if (this.sub4Element && this.subElement) {
      console.log(onlyFourMonthSubscription)
      if (onlyFourMonthSubscription) {
        this.sub4Element.style.display = "flex"
        this.subElement.style.display = "none"
      } else {
        this.sub4Element.style.display = "none"
        this.subElement.style.display = "flex"
      }
    }
  }
  async manageCart() {
    try {
      const cart = await this.fetchCart()
      const onlyFourMonthSubscription = this.checkOnlyFourMonthSubscription(cart)
      this.updateDisplay(onlyFourMonthSubscription)
    } catch (error) {
      console.error("ERROR:", error)
    }
  }
  init() {
    console.log("++++++++++++++++++++++++++++++++++++++++++++++++++++++")
    const savedSubProduct = JSON.parse(localStorage.getItem("subProduct"))
    let bagAddToCart = null
    let bagAddToCartSub = null
    if (document.querySelector("#bag-add-to-cart")) {
      bagAddToCart = document.querySelector("#bag-add-to-cart")
      bagAddToCart.addEventListener("click", () => {
        this.addBag()
      })
    }
    if (document.querySelector("#bag-add-to-cart-sub")) {
      bagAddToCartSub = document.querySelector("#bag-add-to-cart-sub")
      bagAddToCartSub.addEventListener("click", () => {
        this.addSubscriptionBag()
      })
    }
    if (document.querySelector("#bag-add-to-cart-sub4")) {
      document.querySelector("#bag-add-to-cart-sub4").addEventListener("click", () => {
        this.addSubscriptionBag4()
      })
    }
    this.manageCart()
    if (savedSubProduct) {
      const { weight, interval, line } = savedSubProduct
      this.showSelectedSubscription(weight, interval, line)
      localStorage.removeItem("subProduct")
    }

    // Adding listeners to toggle between subscribe and onetime purchase options
    const purchaseTypeCheckboxes = document.querySelectorAll(".template-old input[name='purchase-type']")
    purchaseTypeCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("click", ({ target }) => {
        if (target.id == "subscribe-and-save") {
          window.globalState.purchaseType = target.id
          this.oneTimePurchaseFormBlock.setAttribute("style", "display: none")
          this.subscribeAndSaveFormBlock.removeAttribute("style")
          if (document.querySelectorAll(".hide-block-when-one-time-purchase").length > 0) {
            document.querySelector(".hide-block-when-one-time-purchase").style.display = "block"
          }

          this.renderSubAndSaveOptions()
        }

        if (target.id == "one-time-purchase") {
          window.globalState.selectedBeingEditingVariantLine = null
          window.globalState.purchaseType = target.id
          this.subscribeAndSaveFormBlock.setAttribute("style", "display: none")
          if (document.querySelectorAll(".hide-block-when-one-time-purchase").length > 0) {
            document.querySelector(".hide-block-when-one-time-purchase").style.display = "none"
          }
          this.oneTimePurchaseFormBlock.removeAttribute("style")
          this.calculateWeightAndPrice()
        }

        this.showSavingsValue(`cat_${window.globalState.numberOfCatsSelected}`, window.globalState.productWeight)
        this.showSavingsValueInfo(`cat_${window.globalState.numberOfCatsSelected}`, window.globalState.productWeight)

        let selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == window.globalState.productWeight + "lbs")
        window.globalState.selectedVariantId = window.globalState.allVariants[selectedVariantIndex].id
      })
    })

    // adding listeners to change number of cats by selection
    this.numberOfCatsCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("click", ({ target }) => {
        const { value } = target.dataset
        window.globalState.numberOfCatsSelected = Number(value)
        this.numberOfCatsManualCounterWrapper.classList.remove("active")
        this.calculateWeightAndPrice()

        if (window.globalState.purchaseType === "subscribe-and-save") {
          this.renderSubAndSaveOptions()
        }
      })
    })

    // adding listeners to change number of cats by counter
    this.numberOfCatsManualCounters.forEach((counter) => {
      counter.addEventListener("click", ({ target }) => {
        this.numberOfCatsManualCounterWrapper.classList.add("active")
        this.numberOfCatsCheckboxes.forEach((checkbox) => (checkbox.checked = false))

        const numberOfCatsManualDecrementor = this.numberOfCatsManualCounters[0]
        const numberOfCatsManualIncrementor = this.numberOfCatsManualCounters[1]
        const { action } = target.dataset

        if (action === "increment") {
          if (window.globalState.numberOfCatsSelected < 4) {
            window.globalState.numberOfCatsSelected = parseInt(this.numberOfCatsManualCounterValue.textContent)
          }

          window.globalState.numberOfCatsSelected += 1
          if (window.globalState.numberOfCatsSelected == 10) {
            window.globalState.numberOfCatsSelected = 8
          }
          this.numberOfCatsManualCounterValue.textContent = window.globalState.numberOfCatsSelected
          this.calculateWeightAndPrice()

          if (window.globalState.numberOfCatsSelected > 4) {
            numberOfCatsManualDecrementor.removeAttribute("disabled")
          }

          if (window.globalState.numberOfCatsSelected + 1 === 10) {
            numberOfCatsManualIncrementor.setAttribute("disabled", true)
            window.globalState.numberOfCatsSelected = 8
            const overlay = document.getElementById("overlay")
            overlay.style.display = "block"
            overlay.querySelector(".pdp-modal-form__value").focus()
          }
        }

        if (action === "decrement") {
          if (window.globalState.numberOfCatsSelected < 4) {
            window.globalState.numberOfCatsSelected = parseInt(this.numberOfCatsManualCounterValue.textContent)
          }

          window.globalState.numberOfCatsSelected -= 1
          this.numberOfCatsManualCounterValue.textContent = window.globalState.numberOfCatsSelected
          this.calculateWeightAndPrice()

          if (window.globalState.numberOfCatsSelected === 4) {
            numberOfCatsManualDecrementor.setAttribute("disabled", true)
          }

          if (window.globalState.numberOfCatsSelected < 8) {
            numberOfCatsManualIncrementor.removeAttribute("disabled")
          }
        }

        if (window.globalState.purchaseType === "subscribe-and-save") {
          this.renderSubAndSaveOptions()
        }
      })
    })

    // adding listener to change the state and target class when counter itself is clicked
    this.numberOfCatsManualCounterValue.addEventListener("click", () => {
      this.numberOfCatsManualCounterWrapper.classList.add("active")
      this.numberOfCatsCheckboxes.forEach((checkbox) => (checkbox.checked = false))

      window.globalState.numberOfCatsSelected = parseInt(this.numberOfCatsManualCounterValue.textContent)
      this.calculateWeightAndPrice()

      if (window.globalState.purchaseType === "subscribe-and-save") {
        this.renderSubAndSaveOptions()
      }
    })

    // adding listeners to change the product weight by counter
    this.oneTimePurchaseProductWeightCounters.forEach((counter) => {
      counter.addEventListener("click", ({ target }) => {
        const weightDecrementor = this.oneTimePurchaseProductWeightCounters[0]
        const weightIncrementor = this.oneTimePurchaseProductWeightCounters[1]
        const { action } = target.dataset

        if (action === "increment") {
          window.globalState.productWeight += 10
          this.oneTimePurchaseProductWeightValue.textContent = window.globalState.productWeight + "lbs"
          let cat = window.globalState.productWeight / 10
          this.showSavingsValueInfoOne(`cat_${cat}`, window.globalState.productWeight)
          if (window.globalState.productWeight > 10) {
            weightDecrementor.removeAttribute("disabled")
          }

          if (window.globalState.productWeight + 10 > 80) {
            weightIncrementor.setAttribute("disabled", true)
          }

         
        }

        if (action === "decrement") {
          console.log("decrement")

          if (window.globalState.productWeight - 10 === 0) return

          window.globalState.productWeight -= 10

          this.oneTimePurchaseProductWeightValue.textContent = window.globalState.productWeight + "lbs"

          let cat = window.globalState.productWeight / 10
          this.showSavingsValueInfoOne(`cat_${cat}`, window.globalState.productWeight)
          if (window.globalState.productWeight === 10) {
            weightDecrementor.setAttribute("disabled", true)
          }

          if (window.globalState.productWeight < 80) {
            weightIncrementor.removeAttribute("disabled")
          }

          
        }

        let selectedVariantIndex

        if (window.globalState.productWeight === 10 && window.globalState.purchaseType === "one-time-purchase") {
          this.freeSheepingBlock.setAttribute("style", "display: none")
          selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == "10lbs")
          this.addFreeShippingText(selectedVariantIndex)
        }

        if (window.globalState.productWeight > 10 && window.globalState.purchaseType === "one-time-purchase") {
          console.log("fff")
          selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == `${window.globalState.productWeight}lbs`)

          this.oneTimePurchaseProductPrice.innerHTML = `${this.formatter.format(window.globalState.allVariants[selectedVariantIndex].price / 100)}`
        }

        if (window.globalState.purchaseType === "subscribe-and-save") {
          selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == window.globalState.productWeight + "lbs")
          this.oneTimePurchaseProductPrice.textContent = this.formatter.format(window.globalState.allVariants[selectedVariantIndex].price / 100)
        }

        window.globalState.selectedVariantId = window.globalState.allVariants[selectedVariantIndex].id
        this.updateAddToCartButton();
      })
    })

    const oneTimePurchaseAddToCartButton = document.querySelector(".template-old #one-time-purchase-add-to-cart")
    oneTimePurchaseAddToCartButton.addEventListener("click", () => this.addOneTimePurchaseProductToCart())

    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")

    subscribeAndSaveAddtoCart.addEventListener("click", () => this.addSubscriptionProductToCart())
    purchaseTypeCheckboxes[0].click()

    const modalAddtoCart = document.querySelector(".pdp-modal-form__btn")
    const modalInput = document.querySelector(".pdp-modal-form__value")

    modalAddtoCart.addEventListener("click", () => {
      window.globalState.numberOfCatsSelected = modalInput.value
      this.calculateWeightAndPrice()
      this.addSubscriptionProductToCart2()
      window.globalState.numberOfCatsSelected = 8
      this.numberOfCatsManualCounterValue.textContent = window.globalState.numberOfCatsSelected
      this.overlay.style.display = "none"
    })

    this.closeButton.addEventListener(
      "click",
      function () {
        this.hideOverlay()
      }.bind(this)
    )

    this.updateAddToCartButton();
  }

  hideOverlay() {
    window.globalState.numberOfCatsSelected = 8
    this.numberOfCatsManualCounterValue.textContent = window.globalState.numberOfCatsSelected
    this.overlay.style.display = "none"
  }
  async addOneTimePurchaseProductToCart() {
    console.log("addOneTimePurchaseProductToCart")
    const formData = {
      items: [
        {
          id: window.globalState.selectedVariantId,
          quantity: 1,
          properties: {
            _subscribe: "not_subscribed",
          },
        },
      ],
    }

    const cartItems = await this.getItems()
    const itemIndex = cartItems.items.findIndex((item) => 
      item.id == window.globalState.selectedVariantId && 
      (!item.properties || item.properties._subscribe !== "subscribed")
    )

    if (itemIndex < 0) {
      this.addItem(formData).then((res) => {
        this.toggleCart()
      })
    } else {
      this.toggleCart()
    }
  }
  async addSubscriptionProductToCart() {
    let canAdd = true
    const cartItems = await this.getItems()

    const filteredVariants = cartItems.items.filter((item) => item.id == window.globalState.selectedVariantId)
    
    filteredVariants.forEach((item) => {
      // FIX: Explicitly check that the matching item is a subscription, so one-time items are ignored
      if (item.properties && item.properties._subscribe === "subscribed" && item.properties._interval == window.globalState.rechargeInterval) {
        canAdd = false
      }
    })

    if (!canAdd) {
      this.toggleCart()
      return
    }

    let sellingPlanId = ""

    console.log('------------');
    console.log(window.globalState.rechargeInterval);

    window.globalState.sellingPlans2.forEach((sellingPlan) => {
      console.log(sellingPlan)
      if (sellingPlan.name.includes(window.globalState.rechargeInterval)) {
        sellingPlanId = sellingPlan.selling_plans[0].id
      }
    })
    console.log(window.globalState.selectedVariantId)
    const formData = {
      id: window.globalState.selectedVariantId,
      quantity: 1,
      selling_plan: sellingPlanId,
      properties: {
        _interval: window.globalState.rechargeInterval,
        _subscribe: "subscribed",
      },
    }

    if (window.globalState.selectedBeingEditingVariantLine) {
      this.changeItem({ line: Number(window.globalState.selectedBeingEditingVariantLine), quantity: 0 }).then(async () => {
        window.globalState.selectedBeingEditingVariantLine = null
        this.addItem(formData).then((res) => this.toggleCart())
      })
    } else {
      await this.addItem(formData).then((res) => {
        this.toggleCart()

        console.log("addSubscriptionProductToCart")
        console.log(res)
      })
    }

    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")
    subscribeAndSaveAddtoCart.textContent = "Add To Cart"
  }

  async addSubscriptionBag() {
  console.log("subscr");
  let canAdd = true;

  // Get the cart contents
  const cartItems = await this.getItems();

  // Check if there's cat litter in the cart
  var hasCatLitter = cartItems.items.some((item) => item.product_type === "Cat Litter" && Boolean(item.properties?._interval));

  if (!hasCatLitter) {
    document.getElementById("overlay2").style.display = "block";
    return;
  }

  // Check if this specific subscription is already in the cart
  const filteredVariants = cartItems.items.filter((item) => item.id == window.globalState.selectedVariantId);
  filteredVariants.forEach((item) => {
    if (item.properties._interval == window.globalState.rechargeInterval) {
      canAdd = false;
    }
  });

  if (!canAdd) {
    this.toggleCart();
    return;
  }

  // CRITICAL CHANGE: Find the correct selling plan for this variant
  let sellingPlanId = "";
  
  // Get the button that was clicked to get the interval
  const interval = 2; // Since this is the 2-month subscription button
  
  // Check if current variant is XL
  const isXL = selected_variant.option1 === 'XL';
  console.log("Is XL variant:", isXL);
  
  // Search all selling plan groups for a match
  if (typeof product.selling_plan_groups !== 'undefined') {
    for (const group of product.selling_plan_groups) {
      for (const plan of group.selling_plans) {
        // Log each plan for debugging
        console.log("Checking plan:", plan.name, "id:", plan.id);
        
        // For the 2-month subscription button: check if plan name contains '2 months'
        // and matches the XL status of the current variant
        if (plan.name.includes('2 months') && 
            (isXL ? plan.name.includes('XL') : !plan.name.includes('XL'))) {
          sellingPlanId = plan.id;
          console.log("Found matching plan:", plan.name, "id:", plan.id);
          break;
        }
      }
      if (sellingPlanId) break;
    }
  }
  
  if (!sellingPlanId) {
    console.error("No matching selling plan found for this variant and interval");
    return;
  }
  
  console.log("Selected selling plan ID:", sellingPlanId);
  
  // Create the form data with the correct selling plan ID
  const formData = {
    id: window.globalState.selectedVariantId,
    quantity: 1,
    selling_plan: sellingPlanId,
    properties: {
      _interval: interval,
      _subscribe: "subscribed",
    },
  };

  console.log("Form data being submitted:", formData);

  // Add to cart
  if (window.globalState.selectedBeingEditingVariantLine) {
    this.changeItem({ line: Number(window.globalState.selectedBeingEditingVariantLine), quantity: 0 }).then(async () => {
      window.globalState.selectedBeingEditingVariantLine = null;
      this.addItem(formData).then((res) => this.toggleCart());
    });
  } else {
    await this.addItem(formData).then((res) => {
      this.toggleCart();
      console.log("Add to cart response:", res);
    }).catch(error => {
      console.error("Error adding to cart:", error);
    });
  }

  const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart");
  subscribeAndSaveAddtoCart.textContent = "Add To Cart";
}
  
  async addSubscriptionBag4() {
    console.log("subscr4")
    let canAdd = true

    // this.overlayLoading()

    const cartItems = await this.getItems()

    var hasCatLitter = cartItems.items.some((item) => item.product_type === "Cat Litter" && Boolean(item.properties?._interval))

    if (!hasCatLitter) {
      document.getElementById("overlay2").style.display = "block"
      return
    }

    const filteredVariants = cartItems.items.filter((item) => item.id == window.globalState.selectedVariantId)
    filteredVariants.forEach((item) => {
      if (item.properties._interval == window.globalState.rechargeInterval) {
        canAdd = false
      }
    })

    if (!canAdd) {
      this.toggleCart()
      return
    }

    let sellingPlanId = ""
    window.globalState.sellingPlans.forEach((sellingPlan) => {
      sellingPlanId = sellingPlan.id
    })
    console.log(sellingPlanId)
    const formData = {
      id: 45065132540053, //id 120 bag
      quantity: 1,
      selling_plan: 2308898965, //id selling plan for 4 month
      properties: {
        _interval: window.globalState.rechargeInterval,
        _subscribe: "subscribed",
      },
    }

    if (window.globalState.selectedBeingEditingVariantLine) {
      this.changeItem({ line: Number(window.globalState.selectedBeingEditingVariantLine), quantity: 0 }).then(async () => {
        window.globalState.selectedBeingEditingVariantLine = null
        this.addItem(formData).then((res) => this.toggleCart())
      })
    } else {
      await this.addItem(formData).then((res) => {
        this.toggleCart()
        console.log(res)
      })
    }

    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")
    subscribeAndSaveAddtoCart.textContent = "Add To Cart"
  }
  async addBag() {
    const cartItems = await this.getItems()

    var hasCatLitter = cartItems.items.some((item) => item.product_type === "Cat Litter")

    if (!hasCatLitter) {
      document.getElementById("overlay").style.display = "block"
      return
    }
    const formData = {
      items: [
        {
          id: window.globalState.selectedVariantId,
          quantity: 1,
          properties: {
            _subscribe: "not_subscribed",
          },
        },
      ],
    }

    const itemIndex = cartItems.items.findIndex((item) => item.id == window.globalState.selectedVariantId)
    this.addItem(formData).then((res) => {
      this.toggleCart()
      console.log("addOneTimeBag")
    })
    // if (itemIndex < 0) {
    //   this.addItem(formData).then((res) => {
    //     this.toggleCart()
    //     console.log('addOneTimeBag')
    //   })
    // } else {

    //   console.log('addOneTimeBag itemIndex > 0')
    //   this.toggleCart()
    // }
  }
  async addSubscriptionProductToCart2() {
    let canAdd = true

    const cartItems = await this.getItems()

    let sellingPlanId = ""
    window.globalState.sellingPlans.forEach((sellingPlan) => {
      if (sellingPlan.name.includes(window.globalState.rechargeInterval)) {
        sellingPlanId = sellingPlan.id
      }
    })

    const formData = {
      id: window.globalState.selectedVariantId,
      quantity: window.globalState.count,
      selling_plan: sellingPlanId,
      properties: {
        _interval: window.globalState.rechargeInterval,
        _subscribe: "subscribed",
      },
    }

    if (window.globalState.selectedBeingEditingVariantLine) {
      this.changeItem({ line: Number(window.globalState.selectedBeingEditingVariantLine), quantity: 0 }).then(async () => {
        window.globalState.selectedBeingEditingVariantLine = null
        this.addItem(formData).then((res) => this.toggleCart())
      })
    } else {
      await this.addItem(formData).then((res) => {
        console.log("addSubscriptionProductToCart2")
        console.log(res)
      })
    }

    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")
    subscribeAndSaveAddtoCart.textContent = "Add To Cart"

    let selectedVariantIndex
    window.globalState.productWeight = window.globalState.remainder
    selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == window.globalState.productWeight + "lbs")
    const oneTimePurchaseIndex = window.globalState.allVariants.findIndex((variant) => variant.title == `${window.globalState.productWeight}lbs`)

    this.oneTimePurchaseProductPrice.textContent = this.formatter.format(window.globalState.allVariants[oneTimePurchaseIndex].price / 100)

    window.globalState.selectedVariantId = window.globalState.allVariants[selectedVariantIndex].id

    await this.addSubscriptionProductToCart()
  }

  calculateWeightAndPrice() {
    const weightDecrementor = this.oneTimePurchaseProductWeightCounters[0]

    this.oneTimePurchaseProductWeightValue.textContent = window.globalState.numberOfCatsSelected * 10 + "lbs"
    window.globalState.productWeight = window.globalState.numberOfCatsSelected * 10
    if (window.globalState.productWeight > 10) {
      weightDecrementor.removeAttribute("disabled")
    }

    if (window.globalState.productWeight == 10) {
      weightDecrementor.setAttribute("disabled", true)
    }

    let selectedVariantIndex

    if (window.globalState.numberOfCatsSelected === 1 && window.globalState.purchaseType === "one-time-purchase") {
      selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == "10lbs")
      this.freeSheepingBlock.setAttribute("style", "display: none")
      this.addFreeShippingText(selectedVariantIndex)
      this.showSavingsValue(`cat_${window.globalState.numberOfCatsSelected}`, window.globalState.productWeight)
      this.showSavingsValueInfo(`cat_${window.globalState.numberOfCatsSelected}`, window.globalState.productWeight)
      this.showSavingsValueInfoOne(`cat_${window.globalState.numberOfCatsSelected}`, window.globalState.productWeight)
    }

    if (window.globalState.numberOfCatsSelected > 1 && window.globalState.purchaseType === "one-time-purchase") {
      selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == `${window.globalState.productWeight}lbs`)

      this.oneTimePurchaseProductPrice.innerHTML = `
                  ${this.formatter.format(window.globalState.allVariants[selectedVariantIndex].price / 100)}
              `
      this.showSavingsValue(`cat_${window.globalState.numberOfCatsSelected}`, window.globalState.productWeight)
      this.showSavingsValueInfoOne(`cat_${window.globalState.numberOfCatsSelected}`, window.globalState.productWeight)
    }

    if (window.globalState.purchaseType === "subscribe-and-save") {
      if (window.globalState.productWeight > 80) {
        window.globalState.count = Math.floor(window.globalState.productWeight / 80)
        window.globalState.remainder = window.globalState.productWeight % 80
        window.globalState.productWeight = 80
        selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == window.globalState.productWeight + "lbs")
        const oneTimePurchaseIndex = window.globalState.allVariants.findIndex((variant) => variant.title == `${window.globalState.productWeight}lbs`)

        this.oneTimePurchaseProductPrice.textContent = this.formatter.format(window.globalState.allVariants[oneTimePurchaseIndex].price / 100)

        window.globalState.selectedVariantId = window.globalState.allVariants[selectedVariantIndex].id
        return
      } else {
        selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == window.globalState.productWeight + "lbs")
        const oneTimePurchaseIndex = window.globalState.allVariants.findIndex((variant) => variant.title == `${window.globalState.productWeight}lbs`)
        this.oneTimePurchaseProductPrice.textContent = this.formatter.format(window.globalState.allVariants[oneTimePurchaseIndex].price / 100)
      }
    }

    window.globalState.selectedVariantId = window.globalState.allVariants[selectedVariantIndex].id
    this.updateAddToCartButton();
  }

  changeSubAndSaveOption(interval, weight, cat) {

    window.globalState.rechargeInterval = interval
    window.globalState.productWeight = weight

    const selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == window.globalState.productWeight + "lbs")

    window.globalState.selectedVariantId = window.globalState.allVariants[selectedVariantIndex].id

    this.showSavingsValue(cat, weight);
    this.showSavingsValueInfo(cat, weight);
    this.showSavingsValueInfoOne(cat, weight);

    console.log('interval');
    console.log(interval);
    this.updateAddToCartButton();
  }

  renderSubAndSaveOptionTemplate(cat, selectByDefault) {
      let html = ``;

      for (let index in this.subscriptionOptions[cat]) {
        const option = this.subscriptionOptions[cat][index];
        const reversedIndex = Number(index) - this.subscriptionOptions[cat].length;

        let selectedVariantIndex = window.globalState.allVariants.findIndex((variant) => variant.title == option.weight + "lbs");
        let selectedVariant = window.globalState.allVariants[selectedVariantIndex];

        if (selectedVariantIndex == -1) {
          continue;
        }

        let selectedVariantPriceAfterDiscount = (selectedVariant.price - selectedVariant.price * 0.18) / 100;

        if (Number(index) + 1 === selectByDefault || reversedIndex === selectByDefault) {
          window.globalState.rechargeInterval = option.interval;
          window.globalState.productWeight = option.weight;
          window.globalState.selectedVariantId = selectedVariant.id;
        }

        html += `
          <li class="options__item sss">
            <input 
                data-interval="${option.interval}"
                data-weight="${option.weight}"
                data-cat="${cat}"
                class="options_selector"  
                name="sub-options" 
                id="sub-option-${option.weight}" 
                type="radio" 
                value="${option.interval}"
                hidden
                ${Number(index) + 1 === selectByDefault ? "checked" : ""}
                ${reversedIndex === selectByDefault ? "checked" : ""}
            />
            <label class="label--simple full" for="sub-option-${option.weight}">
                ${
                  option.eco
                    ? `
                    <div class="eco-box eco-updated">
                        <div class="tooltip">
                            <img src="${ecoImg}" alt="" />
                            <div class="text__updated">
                                Fewer shipments = a lower carbon footprint.
                            </div>
                            <div class="square"></div>
                        </div>
                        <span class="eco-label">Eco</span>
                        <span class="eco-label-updated"> <img src="${ecoUpdateImg}" alt="" /></span>
                    </div>
                `
                    : ""
                }
                <div class="weight">
                    <span class="heading">${option.weight}lbs</span>
                    <span class="paragraph">Every ${option.interval === 1 ? "" : option.interval} Month${option.interval > 1 ? "s" : ""}</span>
                </div>
                <div class="price">
                    <span class="paragraph">
                        ${this.formatter.format(selectedVariantPriceAfterDiscount / option.interval)}/month
                    </span>
                    <span class="heading">
                        ${this.formatter.format(selectedVariantPriceAfterDiscount)}
                    </span>
                </div>
            </label>
          </li>   
        `;
      }

      const subscribeAndSaveOptionsWrapper = document.querySelector(".template-old #subscribe-and-save-options");
      subscribeAndSaveOptionsWrapper.innerHTML = html;

      // Fixed event listener attachment
      let inputItems = subscribeAndSaveOptionsWrapper.querySelectorAll('.options__item input');
      for (let i = 0; i < inputItems.length; i++) {
        inputItems[i].addEventListener('change', function (e) {
          if (e.currentTarget.checked == true) {
            // Fixed: changed 'cart' to 'cat'
            window.productFormOld.changeSubAndSaveOption(
              parseInt(e.currentTarget.dataset.interval), 
              parseInt(e.currentTarget.dataset.weight), 
              e.currentTarget.dataset.cat
            );
          }
        });
      }

      this.showSavingsValue(cat, window.globalState.productWeight);
      console.log('hhh');
      this.showSavingsValueInfo(cat, window.globalState.productWeight);
      this.updateAddToCartButton();
    }

  renderSubAndSaveOptions() {
    console.log(window.globalState.numberOfCatsSelected)
    if (window.globalState.numberOfCatsSelected == 3) {
      this.renderSubAndSaveOptionTemplate(`cat_${window.globalState.numberOfCatsSelected}`, 1)
    } else {
      this.renderSubAndSaveOptionTemplate(`cat_${window.globalState.numberOfCatsSelected}`, -1)
    }
  }

  showSelectedSubscription(weight, interval, line) {
    const subscribeAndSaveAddtoCart = document.querySelector(".template-old #subscribe-and-save-add-to-cart")
    subscribeAndSaveAddtoCart.textContent = "Update Cart"

    const cartWrapper = document.querySelector(".template-old .ajax-cart__wrapper")
    cartWrapper.classList.remove("open")
    document.body.removeAttribute("style")

    window.globalState.selectedBeingEditingVariantLine = line
    window.globalState.purchaseType = "subscribe-and-save"
    window.globalState.productWeight = parseInt(weight)

    const purchaseTypeCheckboxes = document.querySelectorAll(".template-old input[name='purchase-type']")
    purchaseTypeCheckboxes[0].checked = true

    this.oneTimePurchaseFormBlock.setAttribute("style", "display: block")

    this.subscribeAndSaveFormBlock.removeAttribute("style")

    for (let cat in this.subscriptionOptions) {
      this.subscriptionOptions[cat].forEach((element, index) => {
        if (element.weight === parseInt(weight) && element.interval === Number(interval)) {
          this.renderSubAndSaveOptionTemplate(cat, Number(index) + 1)

          window.globalState.numberOfCatsSelected = Number(cat.split("_")[1])

          if (window.globalState.numberOfCatsSelected <= 3) {
            this.numberOfCatsCheckboxes.forEach((checkbox) => {
              const { value } = checkbox.dataset

              if (Number(value) === window.globalState.numberOfCatsSelected) {
                checkbox.checked = true
              }
            })
          } else {
            const numberOfCatsManualDecrementor = this.numberOfCatsManualCounters[0]
            const numberOfCatsManualIncrementor = this.numberOfCatsManualCounters[1]

            this.numberOfCatsManualCounterWrapper.classList.add("active")
            this.numberOfCatsCheckboxes.forEach((checkbox) => (checkbox.checked = false))
            this.numberOfCatsManualCounterValue.textContent = window.globalState.numberOfCatsSelected

            if (window.globalState.numberOfCatsSelected > 4) {
              numberOfCatsManualDecrementor.removeAttribute("disabled")
            }

            if (window.globalState.numberOfCatsSelected + 1 === 9) {
              numberOfCatsManualIncrementor.setAttribute("disabled", true)
            }
          }
        }
      })
    }
  }

  showSavingsValue(cat, weight = null) {
    const savingsMapping = {
      cat_1: {
        10: "18%",
        20: "50%",
        40: "57%",
      },
      cat_2: {
        20: "18%",
        40: "29%",
      },
      cat_3: {
        30: "18%",
        60: "23%",
      },
      cat_4: {
        40: "27%",
      },
      cat_5: {
        50: "27%",
      },
      cat_6: {
        60: "27%",
      },
      cat_7: {
        70: "27%",
      },
      cat_8: {
        80: "27%",
      },
    }
    const savingsMapping2 = {
      cat_1: {
        10: "18%",
        20: "48%",
        40: "54%",
      },
      cat_2: {
        20: "14%",
        40: "25%",
      },
      cat_3: {
        30: "18%",
        60: "15%",
      },
      cat_4: {
        40: "13%",
      },
      cat_5: {
        50: "14%",
      },
      cat_6: {
        60: "13%",
      },
      cat_7: {
        70: "14%",
      },
      cat_8: {
        80: "13%",
      },
    }

    const savingValue = savingsMapping[cat] && savingsMapping[cat][weight]
    const savingValue2 = savingsMapping2[cat] && savingsMapping2[cat][weight]
    const highestSavingValue = savingsMapping[cat] && savingsMapping[cat][Object.keys(savingsMapping[cat])[Object.keys(savingsMapping[cat]).length - 1]]
    if (this.checkbox || this.checkbox2) {
      if (this.checkbox.checked || this.checkbox2.checked) {
        if (savingValue) {
          this.setSavingValues("", savingValue2, highestSavingValue)
        }
      } else {
        if (savingValue) {
          this.setSavingValues("", savingValue, highestSavingValue)
        }
      }
    } else {

      if (savingValue) {
        this.setSavingValues("", savingValue, highestSavingValue)
      }
    }
    
  }

  setSavingValues(dollar, percentage, highestSavingValue) {
    const dollarSavings = document.querySelector(".template-old #dollars_saving")
    dollarSavings.textContent = dollar

    const percantageSavings = document.querySelector(".template-old #percantage_saving")
    // if (this.checkbox || this.checkbox2) {
    //   if (this.checkbox.checked || this.checkbox2.checked) {
    //     percantageSavings.textContent = '18%'
    //   } else {
    //     percantageSavings.textContent = percentage
    //   }
    // } else {

    // }
    percantageSavings.textContent = percentage

    const percentageSavingsOneTime = document.querySelector(".template-old #percantage_saving_onetime")
    percentageSavingsOneTime.textContent = highestSavingValue
  }

  showSavingsValueInfo(cat, weight = null) {
      const savingsMapping = {
        cat_1: {
          10: "1x10lbs bag",
          20: "1x20lbs bag",
          40: "2x20lbs bags",
        },
        cat_2: {
          20: "1x20lbs bag",
          40: "2x20lbs bags",
        },
        cat_3: {
          30: "1x20lbs, 1x10lbs bags",
          60: "3x20lbs bags",
        },
        cat_4: {
          40: "2x20lbs bags",
        },
        cat_5: {
          50: "2x20, 1x10lbs bags",
        },
        cat_6: {
          60: "3x20lbs bags",
        },
        cat_7: {
          70: "3x20, 1x10lbs bags",
        },
        cat_8: {
          80: "4x20lbs bags",
        },
      };

      const savingsMapping2 = {
        cat_1: {
          10: "1x10lbs bag",
          20: "2x10lbs bags",
          40: "4x10lbs bags",
        },
        cat_2: {
          20: "2x10lbs bags",
          40: "4x10lbs bags",
        },
        cat_3: {
          30: "3x10lbs bags",
          60: "6x10lbs bags",
        },
        cat_4: {
          40: "4x10lbs bags",
        },
        cat_5: {
          50: "5x10lbs bags",
        },
        cat_6: {
          60: "6x10lbs bags",
        },
        cat_7: {
          70: "7x10lbs bags",
        },
        cat_8: {
          80: "8x10lbs bags",
        },
      };

      let savingValue;

      // Check both checkboxes consistently
      if ((this.checkbox && this.checkbox.checked) || (this.checkbox2 && this.checkbox2.checked)) {
        console.log('checked1 - using 10lb bags only');
        savingValue = savingsMapping2[cat] && savingsMapping2[cat][weight];
      } else {
        console.log('NOchecked1 - using mixed bag sizes');
        savingValue = savingsMapping[cat] && savingsMapping[cat][weight];
      }

      if (savingValue) {
        this.setSavingValuesInfo(weight, savingValue);
      }
    }

  setSavingValuesInfo(weight, value) {
    if (document.querySelector(".template-old .pdp-weight-block__weight-js") && document.querySelector(".template-old .pdp-weight-block__value")) {
      const percantageSavings = document.querySelector(".template-old .pdp-weight-block__weight-js")
      percantageSavings.textContent = weight

      const percentageSavingsOneTime = document.querySelector(".template-old .pdp-weight-block__value")
      percentageSavingsOneTime.textContent = value
    }
  }
 
  showSavingsValueInfoOne(cat, weight = null) {
    const savingsMapping = {
      cat_1: {
        10: "1x10lbs bag",
        20: "1x20lbs bag",
        40: "2x20lbs bags",
      },
      cat_2: {
        20: "1x20lbs bag",
        40: "2x20lbs bags",
      },
      cat_3: {
        30: "1x20lbs, 1x10lbs bags",
        60: "3x20lbs bags",
      },
      cat_4: {
        40: "2x20lbs bags",
      },
      cat_5: {
        50: "2x20, 1x10lbs bags",
      },
      cat_6: {
        60: "3x20lbs bags",
      },
      cat_7: {
        70: "3x20, 1x10lbs bags",
      },
      cat_8: {
        80: "4x20lbs bags",
      },
    };
    
    const savingsMapping2 = {
      cat_1: {
        10: "1x10lbs bag",
        20: "2x10lbs bags",
        40: "4x10lbs bags",
      },
      cat_2: {
        20: "2x10lbs bags",
        40: "4x10lbs bags",
      },
      cat_3: {
        30: "3x10lbs bags",
        60: "6x10lbs bags",
      },
      cat_4: {
        40: "4x10lbs bags",
      },
      cat_5: {
        50: "5x10lbs bags",
      },
      cat_6: {
        60: "6x10lbs bags",
      },
      cat_7: {
        70: "7x10lbs bags",
      },
      cat_8: {
        80: "8x10lbs bags",
      },
    };

    let savingValue;

    // Check both checkboxes consistently
    if ((this.checkbox && this.checkbox.checked) || (this.checkbox2 && this.checkbox2.checked)) {
      console.log('checked - using 10lb bags only');
      savingValue = savingsMapping2[cat] && savingsMapping2[cat][weight];
    } else {
      console.log('NOchecked - using mixed bag sizes');
      savingValue = savingsMapping[cat] && savingsMapping[cat][weight];
    }

    if (savingValue) {
      this.setSavingValuesInfoOne(weight, savingValue);
    }
  }

  showSavingsValue2(cat, weight = null) {
    this.showSavingsValueInfoOne(cat, weight);
  }

  setSavingValuesInfoOne(weight, value) {

    if (document.querySelector(".template-old .pdp-weight-block__weight-js") && document.querySelector(".template-old .pdp-weight-block__value")) {
      const percantageSavings = document.querySelector(".template-old .pdp-weight-block__weight-js--one")
      percantageSavings.textContent = weight

      const percentageSavingsOneTime = document.querySelector(".template-old .pdp-weight-block__value--one")
      percentageSavingsOneTime.textContent = value
    }
  }

  addFreeShippingText(selectedVariantIndex) {
    const text = `
              <span>${this.formatter.format(window.globalState.allVariants[selectedVariantIndex].price / 100)}</span>
              
          `
    this.oneTimePurchaseProductPrice.innerHTML = text
  }
}

window.productFormOld = new ProductFormOld(product, subscriptionOptions)
setTimeout(function () {
  productFormOld.initializeForm()
}, 1000)

/*
  function getCartContents() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        console.log(data); 
       
        data.items.forEach(item => {
          console.log('Product >>>>', item.selling_plan_allocation.selling_plan.options[1].value);
          
        });
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
  
  
  getCartContents();*/

// Function to close the modal
function closeModal(element) {
  element.style.display = "none"
}

// Function to add event listeners
function addModalListeners(overlay, closeBtn) {
  if (!overlay || !closeBtn) return
  closeBtn.addEventListener("click", function () {
    closeModal(overlay)
  })

  window.addEventListener("click", function (event) {
    if (event.target === overlay) {
      closeModal(overlay)
    }
  })
}

// Select overlay elements
const overlay1 = document.getElementById("overlay")
const overlay2 = document.getElementById("overlay2")

// Select close buttons
const closeBtn1 = document.querySelector(".pdp-modal__close")
const closeBtn2 = document.querySelector(".pdp-modal__close2")

// Add listeners to each modal
addModalListeners(overlay1, closeBtn1)
addModalListeners(overlay2, closeBtn2)

